




















































































































































































































































































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import echarts from 'echarts';
import BaseContainer from '@/components/BaseContainer.vue';
import PaginationPanel5 from './components/PaginationPanel5.vue';
import PaginationPanel52 from './components/PaginationPanel5.vue';
import PaginationPanel53 from './components/PaginationPanel5.vue';
import UserDialog from '../setting/component/UserDialog.vue';
import { formRules } from '@/common/util/validator';
import { enums } from '@/common/enums';
import { WorkingTable, yun, Carrier, FeeApi } from '@/http';
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        BaseContainer,
        PaginationPanel5,
        PaginationPanel52,
        PaginationPanel53,
        UserDialog,
    },
})
export default class Dashboard extends Vue {
    public dialogVisibleFee = false;
    handleCloseFee() {
        this.dialogVisibleFee = false;
    }
    public formFee: any = {};

    public formRules = formRules;
    public dialogVisibles = false;
    public handleCloses() {
        this.dialogVisibles = false;
    }
    loadDataList() {}
    public dialogVisible = false;
    handleClose() {
        this.dialogVisible = false;
        setTimeout(() => {
            this.DInfo = {};
            this.GetNotices();
        }, 100);
    }
    public DInfo = {};
    async OpenD(i) {
        try {
            this.DInfo = await WorkingTable.Notice(i.id);
            await WorkingTable.Read(i.id);
            let res = await WorkingTable.GetNoReadCount({});
            this.notificationCount = res.notificationCount;
            this.systemMsgCount = res.systemMsgCount;
            this.dialogVisible = true;
        } catch {
            this.GetNotices();
        }
    }
    async tosysMsg(i) {
        await WorkingTable.ReadSystemMsg(i.id);
        if (i.dataType == 1) {
            this.$router.push({
                path: '/InquiryDetail',
                query: {
                    id: i.dataId,
                    name: 'detail',
                },
            });
        }
        if (i.dataType == 2) {
            this.$router.push({
                path: '/orderDetailcc',
                query: {
                    id: i.dataId,
                    name: 'detail',
                },
            });
        }
        if (i.dataType == 3) {
            let newId = await WorkingTable.GetOrderIdsByCarrierOrderId({ carrierorderid: i.dataId });
            if (newId.length > 0) {
                this.$router.push({
                    path: '/WayBillDetail',
                    query: {
                        id: newId[0],
                        orderId: i.dataId,
                        name: 'detail',
                    },
                });
            }
        }
        if (i.dataType == 4) {
            await FeeApi.GetFeeDetail({ id: i.dataId }).then((res) => {
                this.formFee = res;
                this.dialogVisibleFee = true;
            });
        }
        if (i.dataType == 5) {
            this.$router.push({
                path: '/statementDetails',
                query: {
                    id: i.dataId,
                },
            });
        }
        if (i.dataType == 6) {
            this.$router.push({
                path: '/inquiryDetailEng',
                query: {
                    id: i.dataId,
                    name: 'detail',
                },
            });
        }
    }

    //通过
    public async through(row) {
        await FeeApi.AuditFee({ id: this.formFee.id, feeStatus: 3 })
            .then(() => {
                this.$message.success('审核通过！');
                this.handleCloseFee();
            })
            .catch((err) => {
                this.$message.success('审核失败！');
                this.handleCloseFee();
            });
    }

    //不通过
    public async notThrough(row) {
        await FeeApi.AuditFee({ id: this.formFee.id, feeStatus: 4 })
            .then(() => {
                this.$message.success('审核不通过！');
                this.handleCloseFee();
            })
            .catch((err) => {
                this.$message.success('审核失败！');
                this.handleCloseFee();
            });
    }
    //退回
    public async toBack(row) {
        await FeeApi.AuditFee({ id: this.formFee.id, feeStatus: 2 })
            .then(() => {
                this.$message.success('审核退回！');
                this.handleCloseFee();
            })
            .catch((err) => {
                this.$message.success('审核失败！');
                this.handleCloseFee();
            });
    }
    // 方法
    public ratio = 0;
    public is125 = false;
    public ratioNum = '';
    public ratioNum2 = '';
    public titleNum = '';
    public mes2Num = '';
    detectZoom() {
        this.ratio = 0;
        const screen: any = window.screen;
        const ua = navigator.userAgent.toLowerCase();
        if (window.devicePixelRatio !== undefined) {
            this.ratio = window.devicePixelRatio;
        } else if (~ua.indexOf('msie')) {
            if (screen.deviceXDPI && screen.logicalXDPI) {
                this.ratio = screen.deviceXDPI / screen.logicalXDPI;
            }
        } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
            this.ratio = window.outerWidth / window.innerWidth;
        }
        if (this.ratio) {
            this.ratio = Math.round(this.ratio * 100);
        }
        if (this.ratio <= 100) {
            this.ratioNum = 's100';
            this.ratioNum2 = 's100_';
            this.titleNum = 'w100';
            this.mes2Num = 'wmes100';
        } else if (this.ratio == 110) {
            this.ratioNum = 's110';
            this.ratioNum2 = 's110_';
            this.titleNum = 'w110';
            this.mes2Num = 'wmes110';
        } else if (this.ratio == 125) {
            this.ratioNum = 's125';
            this.ratioNum2 = 's125_';
            this.titleNum = 'w125';
            this.mes2Num = 'wmes125';
        } else if (this.ratio >= 150) {
            this.ratioNum = 's150';
            this.ratioNum2 = 's150_';
            this.titleNum = 'w150';
            this.mes2Num = 'wmes150';
        }
    }
    xjfd2 = false;
    fhfd2 = false;
    fhy2 = false;
    fbgc2 = false;
    cy2 = false;
    xty2 = false;
    //===
    xjd2 = false;
    cwd2 = false;
    hd2 = false;
    cwfsh2 = false;
    fhd2 = false;
    created() {
        console.log(this.$route.path);
        this.$root.$on('newMes', () => {
            if (this.$route.path == '/dashboard') {
                this.loadData();
            }
        });
        let webMenus = JSON.parse(localStorage.getItem('mlssloginAd')).webMenus;
        this.xjfd2 = webMenus.includes('xjfd2');
        this.fhfd2 = webMenus.includes('fhfd2');
        this.fhy2 = webMenus.includes('fhy2');
        this.fbgc2 = webMenus.includes('fbgc2');
        this.cy2 = webMenus.includes('cy2');
        this.xty2 = webMenus.includes('xty2');
        //----
        this.xjd2 = webMenus.includes('xjd2');
        this.cwd2 = webMenus.includes('cwd2');
        this.hd2 = webMenus.includes('hd2');
        this.cwfsh2 = webMenus.includes('cwfsh2');
        this.fhd2 = webMenus.includes('fhd2');
        this.detectZoom();
        this.$nextTick(() => {
            window.addEventListener('resize', () => {
                // 监听浏览器窗口大小改变
                this.detectZoom();
                // 浏览器变化执行动作
            });
        });
        this.loadData();
    }
    toDayData: any = {};
    todoData: any = {};
    public notificationCount = 0;
    public systemMsgCount = 0;
    public async loadData() {
        this.toDayData = await WorkingTable.Today();
        this.todoData = await WorkingTable.Todo();
        this.GetNotices();
        // this.GetSystemMsgs();
        let res = await WorkingTable.GetNoReadCount({});
        this.notificationCount = res.notificationCount;
        this.systemMsgCount = res.systemMsgCount;
        this.AnomalyList();
    }
    anomalyList: any = [];
    public AnomalyList() {
        WorkingTable.AnomalyList({
            skip: this.searchPagin5_3.skip,
            count: this.searchPagin5_3.count,
        })
            .then((res) => {
                this.anomalyList = res.data;
                this.total3 = res.total;
                this.$refs.pagination5_3.setPage(this.searchPagin5_3.currentPage);
            })
            .catch((err) => {});
    }
    formData: any = {};
    formDatay: any = {};
    async chakan(id) {
        this.formDatay = {
            id: '',
            anomalyCode: '',
            carrierOrderCode: '',
            sourceStr: '',
            anomalyTypeEnum: '',
            anomalyTypeStr: '',
            description: '',
            cause: '',
            anomalyPictures: [],
            isOnlySave: true,
        };
        let res = await yun.AnomalyGetDetail(id);
        // console.log('ress', res);
        Object.keys(res).forEach((key) => {
            this.formDatay[key] = res[key];
        });
        this.formDatay.anomalyTypeEnum = Number(this.formDatay.anomalyTypeEnum);
        // this.$refs.formData.resetFields();
        this.dialogVisibles = true;
    }
    noticesData: any = [];
    public GetNotices() {
        WorkingTable.GetNotices({
            skip: this.searchPagin5.skip,
            count: this.searchPagin5.count,
        })
            .then((res) => {
                this.noticesData = res.data;
                this.total = res.total;
                this.$refs.pagination5.setPage(this.searchPagin5.currentPage);
            })
            .catch((err) => {});
    }
    systemMsgsData: any = [];
    public GetSystemMsgs() {
        WorkingTable.GetSystemMsgs({
            skip: this.searchPagin5_2.skip,
            count: this.searchPagin5_2.count,
        })
            .then((res) => {
                this.systemMsgsData = res.data;
                this.total2 = res.total;
                this.$refs.pagination5_2.setPage(this.searchPagin5_2.currentPage);
            })
            .catch((err) => {});
    }
    public rePagin = false;
    public rePagin2 = false;
    public rePagin3 = false;
    total = 0;
    total2 = 0;
    total3 = 0;
    public $refs: {
        pagination5: HTMLFormElement;
        pagination5_2: HTMLFormElement;
        pagination5_3: HTMLFormElement;
        formData: HTMLFormElement;
        UserDialog: HTMLFormElement;
    };
    public searchPagin5: Pagination = {
        skip: 0,
        count: 6,
        currentPage: 1,
    };
    public searchPagin5_2: Pagination = {
        skip: 0,
        count: 6,
        currentPage: 1,
    };
    public searchPagin5_3: Pagination = {
        skip: 0,
        count: 6,
        currentPage: 1,
    };
    public async onPaginationChange5(pagin: Pagination) {
        this.searchPagin5 = pagin;
        this.GetNotices();
    }
    public async onPaginationChange5_2(pagin2: Pagination) {
        this.searchPagin5_2 = pagin2;
        this.GetSystemMsgs();
    }
    public async onPaginationChange5_3(pagin3: Pagination) {
        this.searchPagin5_3 = pagin3;
        this.AnomalyList();
    }
    // public searchItem5 = {
    //     userId: JSON.parse(
    //         window.sessionStorage.getItem('id') ? window.sessionStorage.getItem('id') : window.JSON.parse(localStorage.getItem('mlsslogininfo')).id
    //     ),
    //     IsRead: null,
    // };
    seeMore() {
        this.$router.push('/errorManager');
    }
    jump(flag) {
        if (flag == 1) {
            if (this.xjd2) {
                this.$router.push({
                    path: '/singleInquiry',
                    query: {
                        type: 'dashboard',
                    },
                });
            } else {
                this.$message.warning('没有权限!');
            }
        }
        if (flag == 2) {
            if (this.cwd2) {
                this.$router.push({
                    path: '/costStatement',
                    query: {
                        type: 'dashboard',
                    },
                });
            } else {
                this.$message.warning('没有权限!');
            }
        }
        if (flag == 3) {
            if (this.hd2) {
                this.$router.push({
                    path: '/receiptManager',
                    query: {
                        type: 'dashboard',
                    },
                });
            } else {
                this.$message.warning('没有权限!');
            }
        }
        if (flag == 4) {
            if (this.cwfsh2) {
                this.$router.push({
                    path: '/costAudit',
                    query: {
                        type: 'dashboard',
                    },
                });
            } else {
                this.$message.warning('没有权限!');
            }
        }
        if (flag == 5) {
            if (this.fhd2) {
                this.$router.push({
                    path: '/singleInquiryEng',
                    query: {
                        type: 'dashboard',
                    },
                });
            } else {
                this.$message.warning('没有权限!');
            }
        }
    }
    toPath(num) {
        if (num == 1) {
            if (this.xjfd2) {
                this.$router.push('/addInquiry');
            } else {
                this.$message.warning('没有权限!');
            }
        }
        if (num == 2) {
            if (this.fhfd2) {
                this.$router.push('/addOrder');
            } else {
                this.$message.warning('没有权限!');
            }
        }
        if (num == 3) {
            if (this.fhy2) {
                this.$router.push('/addProject');
            } else {
                this.$message.warning('没有权限!');
            }
        }
        if (num == 4) {
            if (this.fbgc2) {
                this.$router.push('/addInquiryEng');
            } else {
                this.$message.warning('没有权限!');
            }
        }
        if (num == 5) {
            if (this.cy2) {
                this.addNew();
            } else {
                this.$message.warning('没有权限!');
            }
        }
        if (num == 6) {
            if (this.xty2) {
                this.addUser();
            } else {
                this.$message.warning('没有权限!');
            }
        }
    }
    public title2 = '';
    public addUser() {
        this.title2 = '新增员工';
        this.$refs.UserDialog.addOpen();
    }
    public title = '新增承运商';
    public dialogVisible2 = false;
    public addNew() {
        this.title = '新增承运商';
        this.formData = {
            name: '',
            socialCreditCode: '',
            legalPerson: '',
            contactName: '',
            contactPhone: '',
            reconciliationCycle: '',
            paymentCycle: '',
            adminUserName: '',
            adminPassword: '',
            reAdminPassword: '',
        };
        if (this.$refs.formData) {
            this.$refs.formData.resetFields();
        }
        this.dialogVisible2 = true;
    }
    handleClose2() {
        this.formData = {
            name: '',
            socialCreditCode: '',
            legalPerson: '',
            contactName: '',
            contactPhone: '',
            reconciliationCycle: '',
            paymentCycle: '',
            adminUserName: '',
            adminPassword: '',
            reAdminPassword: '',
        };
        this.dialogVisible2 = false;
    }
    save() {
        if (this.formData.adminPassword !== this.formData.reAdminPassword) {
            this.$message.warning('重复密码输入不一致!');
            return;
        }
        this.$refs.formData.validate(async (valid) => {
            if (valid) {
                await Carrier.Add(this.formData);
                this.$message.success('新增成功!');
                this.loadData();
                this.dialogVisible2 = false;
            }
        });
    }
    async DeleteMes() {
        if (this.activeName == 'first') {
            await WorkingTable.Clear({ type: 1 });
            this.$message.success('清空成功!');
            this.GetNotices();
            let res = await WorkingTable.GetNoReadCount({});
            this.notificationCount = res.notificationCount;
            this.systemMsgCount = res.systemMsgCount;
        } else {
            await WorkingTable.Clear({ type: 2 });
            this.$message.success('清空成功!');
            this.GetSystemMsgs();
            let res = await WorkingTable.GetNoReadCount({});
            this.notificationCount = res.notificationCount;
            this.systemMsgCount = res.systemMsgCount;
        }
    }
    activeName = 'first';
    public logText = '系统消息';
    handleClick(tab, event) {
        // if(tab.label)
        console.log(tab.label);
        if (tab.label == '系统消息') {
            this.logText = '系统消息';
            this.GetSystemMsgs();
        }
        if (tab.label == '通知公告') {
            this.logText = '通知公告';
            this.GetNotices();
        }
    }
}
